import React from 'react';
import KjedePicker, { PickedKjede, PickerMode } from 'components/KjedePicker';
import { KjedeType } from 'services/KjederegisteretAdminApi/KjedeApi/types';

interface Props {
  onSelectionChanged: (kjeder: PickedKjede[]) => void;
  selected?: number[];
  pickerMode: PickerMode;
  disabled?: boolean;
  includeFuture?: boolean;
}

const MarkedsKjedePicker = (props: Props) => {
  return (
    <KjedePicker
      pickerMode={props.pickerMode}
      onSelectionChanged={props.onSelectionChanged}
      selected={props.selected}
      kjedeType={KjedeType.Marked}
      disabled={props.disabled}
      includeFuture={props.includeFuture}
    />
  );
};

export default MarkedsKjedePicker;
